import React, {useEffect, useState} from "react";

function AddAdSlotModal({isOpen, isSaving = false, onClose, onSubmit}) {
	const [keyValue, setKeyValue] = useState("");
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [isActive, setIsActive] = useState(true);
	const [formError, setFormError] = useState("");

	useEffect(() => {
		if (!isOpen) return;
		setKeyValue("");
		setName("");
		setDescription("");
		setIsActive(true);
		setFormError("");
	}, [isOpen]);

	if (!isOpen) return null;

	const handleSubmit = async () => {
		if (!keyValue.trim() || !name.trim()) {
			setFormError("Slot key and slot name are required.");
			return;
		}

		setFormError("");
		await onSubmit({
			key: keyValue.trim(),
			name: name.trim(),
			description: description.trim(),
			active: isActive,
		});
	};

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(0,0,0,0.45)] px-4">
			<div className="w-full max-w-[560px] rounded-xl bg-white p-6 shadow-[0_12px_32px_rgba(0,0,0,0.15)]">
				<div className="mb-5 flex items-start justify-between">
					<div>
						<h3 className="text-2xl font-semibold text-[#1E1F21]">Add ad slot</h3>
						<p className="mt-1 text-sm text-[#6D6E6F]">Create a new placement slot for studio ads.</p>
					</div>
					<button
						type="button"
						onClick={onClose}
						disabled={isSaving}
						className="rounded-md px-2 py-1 text-[#6D6E6F] hover:bg-[#F4F4F5] disabled:opacity-60"
					>
						✕
					</button>
				</div>

				<div className="space-y-4">
					<div>
						<label className="mb-2 block text-sm font-medium text-[#1E1F21]">Slot key</label>
						<input
							type="text"
							value={keyValue}
							onChange={(e) => setKeyValue(e.target.value)}
							placeholder="home_top_banner"
							className="h-11 w-full rounded-md border border-[#DADADA] px-3 text-sm outline-none focus:border-[#31A762]"
						/>
					</div>

					<div>
						<label className="mb-2 block text-sm font-medium text-[#1E1F21]">Slot name</label>
						<input
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder="Home Top Banner"
							className="h-11 w-full rounded-md border border-[#DADADA] px-3 text-sm outline-none focus:border-[#31A762]"
						/>
					</div>

					<div>
						<label className="mb-2 block text-sm font-medium text-[#1E1F21]">Description</label>
						<textarea
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							placeholder="Optional description"
							className="min-h-[96px] w-full rounded-md border border-[#DADADA] px-3 py-2 text-sm outline-none focus:border-[#31A762]"
						/>
					</div>

					<label className="flex items-center gap-2 text-sm text-[#1E1F21]">
						<input
							type="checkbox"
							checked={isActive}
							onChange={(e) => setIsActive(e.target.checked)}
							className="h-4 w-4 accent-[#31A762]"
						/>
						Active
					</label>
				</div>

				{formError ? (
					<p className="mt-3 rounded-md bg-[#FBEAEC] px-3 py-2 text-sm text-[#842029]">{formError}</p>
				) : null}

				<div className="mt-6 flex justify-end gap-3">
					<button
						type="button"
						onClick={onClose}
						disabled={isSaving}
						className="rounded-md border border-[#D5D5D5] px-4 py-2 text-sm font-semibold text-[#1E1F21] disabled:opacity-60"
					>
						Cancel
					</button>
					<button
						type="button"
						onClick={handleSubmit}
						disabled={isSaving}
						className="rounded-md bg-[#31A762] px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
					>
						{isSaving ? "Saving..." : "Create slot"}
					</button>
				</div>
			</div>
		</div>
	);
}

export default AddAdSlotModal;
